import axios from 'axios'

const base = '/v2/portal'

export default {
  getMeta () {
    return axios.get(`${base}/certificate-meta`).then(response => response.data)
  },
  getCertificates (params) {
    return axios.get(`${base}/certificates`, { params }).then(response => response.data)
  },
  getCertificate (uuid) {
    return axios.get(`${base}/certificates/${uuid}`).then(response => response.data)
  },
  createCertificate (payload) {
    return axios.post(`${base}/certificates`, payload).then(response => response.data)
  },
  preview (payload) {
    return axios.post(`${base}/certificates/preview`, payload, { responseType: 'blob' })
  },
  cancel (uuid, reason) {
    return axios.post(`${base}/certificates/${uuid}/cancel`, { reason }).then(response => response.data)
  },
  retry (uuid) {
    return axios.post(`${base}/certificates/${uuid}/retry-generation`).then(response => response.data)
  },
  download (uuid) {
    return axios.get(`${base}/certificates/${uuid}/download`, { responseType: 'blob' })
  },
  attachPeople (uuid, payload) {
    return axios.post(`${base}/certificates/${uuid}/people`, payload).then(response => response.data)
  },
  detachPeople (uuid, linkId) {
    return axios.delete(`${base}/certificates/${uuid}/people/${linkId}`).then(response => response.data)
  },
  getPeopleCertificates (peopleUuid, params) {
    return axios.get(`${base}/peoples/${peopleUuid}/certificates`, { params }).then(response => response.data)
  },
  searchPeople (params) {
    // is_active must be sent explicitly: PeopleController@datasource tests
    // `request()->is_active == 0`, and a missing value (null) satisfies that
    // loose comparison, silently returning only inactive people.
    return axios.get('/people/datasource', {
      params: Object.assign({ sortby: 'firstname', sortbydesc: 'asc', per_page: 10, is_active: 1 }, params)
    }).then(response => response.data)
  },
  getConfiguration () {
    return axios.get(`${base}/certificate-configuration`).then(response => response.data)
  },
  getConstants () {
    return axios.get(`${base}/certificate-configuration/constants`).then(response => response.data)
  },
  updateConstants (constants) {
    return axios.put(`${base}/certificate-configuration/constants`, { constants }).then(response => response.data)
  },
  updateSettings (payload) {
    return axios.put(`${base}/certificate-configuration/settings`, payload).then(response => response.data)
  },
  createMaster (resource, payload) {
    return axios.post(`${base}/certificate-masters/${resource}`, payload).then(response => response.data)
  },
  updateMaster (resource, id, payload) {
    return axios.put(`${base}/certificate-masters/${resource}/${id}`, payload).then(response => response.data)
  },
  createField (documentTypeId, payload) {
    return axios.post(`${base}/certificate-document-types/${documentTypeId}/fields`, payload).then(response => response.data)
  },
  updateField (documentTypeId, fieldId, payload) {
    return axios.put(`${base}/certificate-document-types/${documentTypeId}/fields/${fieldId}`, payload).then(response => response.data)
  },
  uploadTemplate (formData) {
    return axios.post(`${base}/certificate-templates`, formData).then(response => response.data)
  },
  activateTemplate (templateId) {
    return axios.post(`${base}/certificate-templates/${templateId}/activate`).then(response => response.data)
  },
  deactivateTemplate (templateId) {
    return axios.post(`${base}/certificate-templates/${templateId}/deactivate`).then(response => response.data)
  },
  updateMappings (templateId, mappings) {
    return axios.put(`${base}/certificate-templates/${templateId}/mappings`, { mappings }).then(response => response.data)
  },
  uploadTemplatePage (templateId, formData) {
    return axios.post(`${base}/certificate-templates/${templateId}/pages`, formData).then(response => response.data)
  },
  getTemplateBackground (templateId, page = 1) {
    return axios.get(`${base}/certificate-templates/${templateId}/background`, { params: { page }, responseType: 'blob' })
  },
  getEditorBackground (templateId, page = 1) {
    return axios.get(`${base}/certificate-editor/templates/${templateId}/background`, { params: { page }, responseType: 'blob' })
  },
  getEditorAsset (assetId) {
    if (!/^\d+$/.test(String(assetId))) return Promise.reject(new Error('Invalid certificate asset ID.'))
    return axios.get(`${base}/certificate-editor/assets/${assetId}/file`, { responseType: 'blob' })
  },
  uploadAsset (formData) {
    return axios.post(`${base}/certificate-assets`, formData).then(response => response.data)
  },
  updateAsset (assetId, payload) {
    return axios.put(`${base}/certificate-assets/${assetId}`, payload).then(response => response.data)
  }
}
